import { useQuery } from '@tanstack/react-query';

import type { SnapshotEnvelope } from '../api/contract';
import { useAccountApi, useAppData } from '../app/AppContext';

export function useSnapshot() {
  const { apiGet, requireFinanceV3 } = useAccountApi();
  const { workspace } = useAppData();
  return useQuery({
    queryKey: ['finance', workspace?.id, 'snapshot'],
    enabled: workspace !== undefined,
    queryFn: async () => {
      const result = await apiGet<SnapshotEnvelope>(`/workspaces/${workspace!.id}/finance-snapshot`);
      requireFinanceV3(result);
      return result;
    },
    retry: false,
  });
}
